import React, { useEffect, useState } from 'react';
import {
  Container, Typography, Box, TextField, Button, Alert,
  FormControl, InputLabel, Select, MenuItem
} from '@mui/material';
import { useParams, useNavigate } from 'react-router-dom';
import axiosInstance from '../../services/api';

const AdminVehicleModelForm = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const isEdit = !!id;

  const [name, setName] = useState('');
  const [slug, setSlug] = useState('');
  const [vehicleBrandId, setVehicleBrandId] = useState('');
  const [displayOrder, setDisplayOrder] = useState(0);
  const [brands, setBrands] = useState([]);
  const [error, setError] = useState('');

  useEffect(() => {
    axiosInstance.get('/vehiclebrands').then(res => setBrands(res.data)).catch(() => {});
    if (id) {
      axiosInstance.get(`/vehiclemodels/${id}`)
        .then(res => {
          setName(res.data.name);
          setSlug(res.data.slug);
          setVehicleBrandId(res.data.vehicleBrandId);
          setDisplayOrder(res.data.displayOrder);
        })
        .catch(() => setError('Model bilgileri alınamadı.'));
    }
  }, [id]);

  const handleNameChange = (val) => {
    setName(val);
    if (!isEdit) {
      setSlug(val.toLowerCase()
        .replace(/ğ/g, 'g').replace(/ü/g, 'u').replace(/ş/g, 's')
        .replace(/ı/g, 'i').replace(/ö/g, 'o').replace(/ç/g, 'c')
        .replace(/\s+/g, '-').replace(/-+/g, '-').trim());
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const token = localStorage.getItem('adminToken');
    const data = { name, slug, vehicleBrandId, displayOrder: Number(displayOrder) };
    try {
      if (isEdit) {
        await axiosInstance.put(`/vehiclemodels/${id}`, data, {
          headers: { Authorization: `Bearer ${token}` }
        });
      } else {
        await axiosInstance.post('/vehiclemodels', data, {
          headers: { Authorization: `Bearer ${token}` }
        });
      }
      navigate('/admin/vehicles/models');
    } catch (err) {
      setError('Kayıt başarısız: ' + (err.response?.data || err.message));
    }
  };

  return (
    <Container maxWidth="sm">
      <Box sx={{ mt: 4 }}>
        <Typography variant="h5" fontWeight={700} sx={{ mb: 3 }}>
          {isEdit ? 'Modeli Düzenle' : 'Yeni Model Ekle'}
        </Typography>
        {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
        <form onSubmit={handleSubmit}>
          <FormControl fullWidth required margin="normal">
            <InputLabel>Marka</InputLabel>
            <Select label="Marka" value={vehicleBrandId} onChange={e => setVehicleBrandId(e.target.value)}>
              {brands.map(b => <MenuItem key={b.id} value={b.id}>{b.name}</MenuItem>)}
            </Select>
          </FormControl>
          <TextField label="Model Adı" fullWidth required margin="normal"
            value={name} onChange={e => handleNameChange(e.target.value)} />
          <TextField label="Slug (URL)" fullWidth margin="normal"
            value={slug} onChange={e => setSlug(e.target.value)}
            helperText="Otomatik üretilir, değiştirebilirsiniz." />
          <TextField label="Sıralama" fullWidth margin="normal" type="number"
            value={displayOrder} onChange={e => setDisplayOrder(e.target.value)} />
          <Box sx={{ display: 'flex', gap: 2, mt: 2 }}>
            <Button type="submit" variant="contained" color="primary" fullWidth>
              {isEdit ? 'Güncelle' : 'Oluştur'}
            </Button>
            <Button variant="outlined" fullWidth onClick={() => navigate('/admin/vehicles/models')}>
              İptal
            </Button>
          </Box>
        </form>
      </Box>
    </Container>
  );
};

export default AdminVehicleModelForm;
